import { useState, useCallback } from 'react';

const useControllableState = ({
  value,
  defaultValue,
  onValueChange = () => {
  }
}) => {
  const [controlledValue, setControlledValue] = useState(defaultValue);
  const [previousDefaultValue, setPreviousDefaultValue] = useState(defaultValue);
  if (defaultValue !== previousDefaultValue) {
    setPreviousDefaultValue(defaultValue);
    console.warn(
      "useControllableState: `defaultValue` is changing after component is mounted. Changing `defaultValue` will not change the initial value of the component."
    );
  }
  const handleControlledChange = (value_) => {
    setControlledValue(value_);
    onValueChange?.(value_);
  };
  if (value !== void 0) {
    return [value, onValueChange];
  }
  return [controlledValue, handleControlledChange];
};

const useError = () => {
  const [error, setError] = useState();
  const [previousError, setPreviousError] = useState();
  if (error && error !== previousError) {
    setPreviousError(error);
    throw error;
  }
  const dispatchError = useCallback((error2) => {
    setError(error2);
  }, []);
  return dispatchError;
};

export { useControllableState, useError };
